<template>
  <div class="nsale_">
    <div class="con_1">
      <img src="./../../../assets/image/input_icon.png" alt="">
      <cube-input style="width: 100%;text-align:left;" v-model="reserve1" placeholder="用户帐号/名称" @input="queryTemplateForBaoSiByUserId()"></cube-input>
    </div>
    <div class="outer" v-for="(item, index) in list" :key="index">
      <div class="inner" :class="{ move: candelete == index }">
        <div class="in_2" @click="toDetail(index, item)">
          <div class="in_2Left">
            <div class="in_txt in_txt1">{{ item.tempName }}
              <img class="in_2img" src="../../../assets/image/nsale/arrow.png" alt="arr" /></div>
            <p class="in_txt">创建时间：{{ item.createTimeStr }}</p>
            <p class="in_txt" style="margin-top: 5px;">使用用户数：{{ item.useCount }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="nomore" class="nomore">没有更多数据了</div>
    <div v-if="list.length === 0" class="nodata">暂无数据</div>
  </div>
</template>

<script>
  import api from '@/utils/api'
  export default {
    data() {
      return {
        nomore: false,
        clientNum: {}, // 记录开始滑动（x1）,结束滑动（x2）的鼠标指针的位置
        candelete: {}, // 滑动的item
        colorList: ['#34D54B', '#FFA749', '#F7E125'],
        list: [],
        reserve1:'',
        pagation: {
          pageNum: 1,
          pageSize: 10,
        },
        clientHeight: 0, // 可视区的高度
        scrollTop: 0, // 滚动条滚动时，距离顶部的距离
        scrollHeight: 0 // 滚动条的总高度
      }
    },
    created() {
      window.addEventListener('scroll', this.listenerFunction)
    },
    destroyed() {
      window.removeEventListener('scroll', this.listenerFunction)
    },
    mounted() {
      this.hideOptionMenu()
      this.userId = this.$route.query.userId
      this.getToken().then(() => {
        this.queryTemplateForBaoSiByUserId(false)
      })
    },
    methods: {
      listenerFunction() {
        debugger
        let timer = null
        this.scrollTop =
          document.documentElement.scrollTop || document.body.scrollTop // 可视区的高度
        this.clientHeight =
          document.documentElement.clientHeight || document.body.clientHeight // 滚动条滚动时，距离顶部的距离
        this.scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight // 滚动条的总高度

        if (this.scrollTop + this.clientHeight >= this.scrollHeight) {
          timer = setTimeout(() => {
            // 延迟500ms加载数据
            if (this.pagation.pageNum < this.pagation.pages) {
              this.pagation.pageNum++
              this.queryTemplateForBaoSiByUserId(true)
            } else {
              this.nomore = true
            }
          }, 500)
        }
      },
      hideOptionMenu() {
        document.addEventListener(
          'WeixinJSBridgeReady',
          function onBridgeReady() {
            WeixinJSBridge.call('hideOptionMenu')
          }
        )
      },
      wxpay() {
        var vm = this
        if (typeof WeixinJSBridge === 'undefined') {
          // 微信浏览器内置对象。参考微信官方文档
          if (document.addEventListener) {
            document.addEventListener(
              'WeixinJSBridgeReady',
              vm.onBridgeReady(),
              false
            )
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady())
            document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady())
          }
        } else {
          vm.onBridgeReady()
        }
      },
      onBridgeReady: function () {
        WeixinJSBridge.call('hideOptionMenu')
      },
      getToken() {
        return api.getToken({ userId: this.userId }).then(res => {
          localStorage.setItem('token', res.data.content)
        })
      },
      queryTemplateForBaoSiByUserId(flag) {
        if (!flag) {
          this.pagation.pageNum = 1
          this.list = []
          this.nomore = false
        }
        if(this.reserve1){
          this.list = []
        }
        let params = {
          ...this.pagation,
          reserve1: this.reserve1
        }
        api.queryTemplateForBaoSiByUserId({}, params).then(res => {
          if (res.data.content) {
            this.pagation.total = res.data.content.total
            this.pagation.pages = Math.ceil(
              res.data.content.total / this.pagation.pageSize
            )
            if (!flag) {
              this.list = res.data.content.list
            } else {
              this.list = this.list.concat(res.data.content.list)
            }
          }
        })
      },
      updateUser(data) {
        api.updateUser(data).then(res => {
          this.showToast('操作成功')
          this.queryTemplateForBaoSiByUserId()
        })
      },
      showToast(text) {
        this.$createToast({
          txt: text,
          time: 1000,
          type: 'txt'
        }).show()
      },
      handleDelete(item) {
        console.log('删除', item)
        let data = {
          id: item.id,
          forbiddenType: '1',
          deleteFlag: '1'
        }
        this.updateUser(data)
      },
      toDetail(index, item) {
        debugger
        this.$router.push({ path: `/nsale/team`, query:{
          teamTemplateId:item.id,
          userId:this.$route.query.userId,
          appId:this.$route.query.appId,
          searchChars:this.reserve1
        } })
      },
      touchStart(index) {
        let touchs = event.changedTouches[0]
        // 记录开始滑动的鼠标位置
        this.clientNum.x1 = touchs.pageX
      },
      touchEnd(index) {
        let touchs = event.changedTouches[0]
        // 记录结束滑动的鼠标位置
        this.clientNum.x2 = touchs.pageX
        // 判断滑动距离大于50，判定为滑动成功，否则失败
        if (
          this.clientNum.x2 < this.clientNum.x1 &&
          Math.abs(this.clientNum.x1) - Math.abs(this.clientNum.x2) > 50
        ) {
          event.preventDefault()
          this.candelete = index
        } else if (
          this.clientNum.x2 > this.clientNum.x1 &&
          Math.abs(this.clientNum.x2) - Math.abs(this.clientNum.x1) > 50
        ) {
          event.preventDefault()
          this.candelete = {}
        }
      }
    }
  }
</script>
<style>
  .nsale_ .con_1 {
    padding: 10px 0;
  }
  .nsale_ .cube-input-field::placeholder {
    text-align: left;
}

  .nsale_ .con_1 .cube-input-field {
    height: 35px !important;
    text-align: left !important;
    padding-left: 30px !important;
    border-radius: 7px !important;
  }
</style>
<style scoped lang="scss">
  .con_1 {
    position: relative;

    .cube-input {}

    img {
      position: absolute;
      left: 10px;
      width: 15px;
      z-index: 999;
      top: 20px;
    }
  }

  .nsale_ {
    font-family: PingFang SC;
    background: fff;
    min-height: 100vh;
    padding: 0 20px;
    .outer {
      overflow: hidden;
      background: #fff;

      .inner {
        display: flex;
        width: 100%;

        .in_1,
        .in_2,
        .in_3 {
          height: 75px;
        }

        .in_2 {
        width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .in_2Left {
        width: 100%;
            text-align: left;
          }

          .in_txt {
            font-size: 13px;
            color: rgba(102, 102, 102, 1);
          }

          .in_txt1 {
            font-size: 15px;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 10px;
            img{
              float: right;
            }
          }

          .in_2img {
            height: 13px;
            width: auto;
          }
        }

        .in_3 {
          width: 68px;
          line-height: 75px;
          background: rgba(204, 204, 204, 1);
          font-size: 12px;
          color: rgba(255, 255, 255, 1);
        }
      }

      .inner.move {
        transform: translateX(-68px);
      }
    }
  }

  .null_ {
    padding-top: 70px;
    font-size: 13px;
    color: rgba(153, 153, 153, 1);

    img {
      height: 130px;
      width: auto;
    }

    .nullTxt {
      width: 246px;
      line-height: 20px;
      margin: 10px auto 0;
    }
  }

  .nomore {
    font-size: 13px;
    padding: 10px 0;
  }

  .nodata {
    font-size: 20px;
    height: 100vh;
    line-height: 100vh;
  }
</style>